import { AppThunk } from '../../../../storage/store';
import { signInStart, signInSuccess, signInFailed } from './slice';
import { signInAPI } from './api';
import { setToken } from '../../../../utils/auth';
import { SignInRequest } from '../../model/auth';

export const postSignIn = (data: SignInRequest): AppThunk => async (dispatch) => {
  dispatch(signInStart());
  try {
    const response = await signInAPI(data);
    // Response shape: { code, status, data: { user, access_token } }
    const token = response?.data?.access_token;
    if (token) {
      setToken(token);
      dispatch(signInSuccess());
    } else {
      dispatch(signInFailed('Login failed. No token received.'));
    }
  } catch (err: any) {
    const message =
      err?.message ||
      err?.error ||
      (typeof err === 'string' ? err : 'Something went wrong. Please try again.');
    dispatch(signInFailed(message));
  }
};
